import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {setOpenContactForm} from '../../../redux/slices/contactFormSlice';
import {
    profileMethod,
    setOpenProfileMethod,
} from '../../../redux/slices/profileMethodSlice';
import Button from '../../components/Button/Button';
import './styles.scss';
import gsap from 'gsap';

function ProfileMethod() {
    const dispatch = useDispatch();
    const isProfileMethodOpen = useSelector(profileMethod);
    const tl = useRef(null);

    useEffect(() => {
        if (!isProfileMethodOpen) return;

        tl.current = gsap.timeline();

        tl.current.fromTo(
            '.profile-method',
            {y: '100%', opacity: 0},
            {y: '0%', opacity: 1, duration: 0.4, ease: 'power2.out'}
        );

        tl.current.fromTo(
            '.profile-method__wrapper',
            {x: '100%'},
            {x: '0%', duration: 0.5, ease: 'power2.out'}
        );

        tl.current.fromTo(
            ['.profile-method__logo', '.profile-method__close'],
            {opacity: 0, y: 20},
            {opacity: 1, y: 0, duration: 0.4, stagger: 0.1}
        );

        tl.current.fromTo(
            '.profile-method__title',
            {x: -50, opacity: 0},
            {x: 0, opacity: 1, duration: 0.5}
        );

        tl.current.fromTo(
            '.profile-method__text-box',
            {opacity: 0, y: 30},
            {opacity: 1, y: 0, duration: 0.5}
        );

        tl.current.fromTo(
            '.profile-method__form-button',
            {autoAlpha: 0, y: 20},
            {autoAlpha: 1, y: 0, duration: 0.4}
        );

        document.body.classList.add('menu-open');

        return () => {
            tl.current.reverse();
            tl.current.eventCallback('onReverseComplete', () => {
                document.body.classList.remove('menu-open');
            });
        };
    }, [isProfileMethodOpen]);

    return (
        <div className="profile-method">
            <div className="profile-method__wrapper">
                <div className="container">
                    <div className="profile-method__top">
                        <Link className="profile-method__logo" to="/">
                            <img
                                src="./images/icons/logo-black.svg"
                                alt="логотип"
                            />
                        </Link>
                        <div className="profile-method__close">
                            <button
                                className="close-button"
                                onClick={() =>
                                    dispatch(setOpenProfileMethod(false))
                                }
                            >
                                <div className="in">
                                    <div className="close-button-block"></div>
                                    <div className="close-button-block"></div>
                                </div>
                                <div className="out">
                                    <div className="close-button-block"></div>
                                    <div className="close-button-block"></div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div className="profile-method__content">
                        <h2 className="profile-method__title form-title">
                            АРХЕТИПИЧЕСКИЙ ПСИ-ПРОФИЛЬ
                        </h2>
                        <div className="profile-method__text-box">
                            {[
                                'Представь, что ты с самого рождения носишь в себе личную инструкцию по эксплуатации. Но написана она не на русском, а на языке символов — архетипов. Твоя дата рождения — это не просто цифры в паспорте, а ключ к твоим внутренним настройкам.',

                                'Помнишь Юнга, которого мы в институте проходили? Он говорил, что есть какие-то универсальные сценарии — архетипы. Так вот, есть метод, где взяты 22 Высших Аркана Таро как 22 архетипа, и по твоей дате рождения выстроена личная карта из более чем 30 позиций.',

                                'Звучит как магия? А вот и нет — это психология, просто с очень красивой упаковкой.',

                                'Есть 22 архетипа — универсальные роли, характеры и сценарии. Например: «Маг» вечно генерит идеи, «Императрица» обожает уют и красоту, «Повешенный» всё время кем-то жертвует. У каждого из нас внутри живёт целый театр из таких ролей.',

                                'Глядя на твою карту, я могу сказать, какая твоя базовая энергия, какие уроки ты будешь проходить всю жизнь, какой твой скрытый экзаменатор, как ты мыслишь, что чувствуешь в стрессе и какая у тебя главная жизненная тема.',

                                'Зачем это надо? Первое: ты видишь, почему ты в одном и том же сценарии отжигаешь, словно заезженная пластинка. Почему с одними людьми легко, а с другими как на минном поле. Это диагностика. А второе: понимаешь, куда двигаться дальше — прогноз. В кризис, при смене работы, в отношениях — помогает не тупить, а принимать взрослые решения.',

                                'Это не про предсказания. Это про осознанность. Ты перестаёшь ходить по кругу и начинаешь делать выборы, которые реально подходят именно тебе.',

                                'Короче, если хочешь перестать быть «вечной Золушкой» или «спасателем всех котов» — дай знать. Построим и разберем твой профиль по клеточкам.',
                            ].map((text, i) => (
                                <p className="profile-method__text" key={i}>
                                    {text}
                                </p>
                            ))}

                            <div className="profile-method__form-bottom">
                                <Button
                                    text="СВЯЖИСЬ СО МНОЙ"
                                    className="profile-method__form-button button--black"
                                    onClick={() =>
                                        dispatch(setOpenContactForm(true))
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProfileMethod;
